export default __webpack_public_path__ + "static/pamela2-c35fac624fd11a60486addd0f443fdc5.png";